
class Storage {
  constructor(id) {
    this.id = id;
  }

  save = (data) => localStorage.setItem(this.id, data);
  get = () => localStorage.getItem(this.id);
  delete = () => localStorage.removeItem(this.id)
};

export default Storage;
